import { SVGProps } from "react";

export const SendIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="send">
      <mask
        id="mask0_5249_23566"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={20}
        height={20}
      >
        <rect id="Bounding box" width={20} height={20} fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5249_23566)">
        <path
          id="send_2"
          d="M2.5 16.6663V3.33301L18.3333 9.99967L2.5 16.6663ZM4.16667 14.1663L14.0417 9.99967L4.16667 5.83301V8.74967L9.16667 9.99967L4.16667 11.2497V14.1663Z"
          style={{ fill: 'var(--color-text-primary)' }}
        />
      </g>
    </g>
  </svg>
);
